import React, { Component } from "react";
import PropTypes from "prop-types";
import DropzoneS3Uploader from "react-dropzone-s3-uploader";
import UploadedImageDisplay from "./UploadedImageDisplay";

export default class ImageUploader extends Component {
  handleFinishedUpload = info => {
    // eslint-disable-next-line
    console.log("Access it on s3 at", info.publicUrl); 
    this.props.onChange({
      target: {
        name: this.props.name,
        value: info.publicUrl
      }
    });
  };

  render() {
    const uploadOptions = {
      server: process.env.REACT_APP_SITE_API,
      signingUrl: "/images/upload",
      uploadRequestHeaders: { "x-amz-acl": "private" }
    };

    const s3Url = `https://${
      process.env.REACT_APP_IMAGE_BUCKET
    }.s3.amazonaws.com`;

    return (
      <DropzoneS3Uploader
        onFinish={this.handleFinishedUpload}
        onError={console.log} // eslint-disable-line
        s3Url={s3Url}
        maxSize={1024 * 1024 * 5}
        upload={uploadOptions}
        filename={this.props.filename}
        style={{ padding: 10, border: "dashed 2px gray" }}
        onChange={this.props.onChange}
      >
        <UploadedImageDisplay
          background={this.props.background}
          onChange={this.handleFinishedUpload}
        />
      </DropzoneS3Uploader>
    );
  }
}

ImageUploader.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  background: PropTypes.string,
  filename: PropTypes.string
};

ImageUploader.defaultProps = {
  background: "#FFF",
  filename: ""
};
